module.exports = __webpack_public_path__ + "img/img6.633f4911.png";